export default {
    related: "Related blogposts",
}